import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrueFalseCombo',
  props: {
    nullable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { nullable: boolean };


const { nullable } = toRefs(props);

return { __sfc: true,props, nullable }
}

})